module.exports = __webpack_public_path__ + "img/teleradio-home-hero.255baeee.webp";